export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              联系我们
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              欢迎投稿、合作与反馈
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-background-50 rounded-2xl p-6 md:p-8">
              <h3 className="text-lg font-heading text-foreground-900 mb-4">
                联系信息
              </h3>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800">投稿邮箱</p>
                    <p className="text-sm text-foreground-600">submit@bangbangtv.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-customer-service-2-line text-accent-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800">客服支持</p>
                    <p className="text-sm text-foreground-600">support@bangbangtv.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-shake-hands-line text-secondary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800">商务合作</p>
                    <p className="text-sm text-foreground-600">biz@bangbangtv.com</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-background-50 rounded-2xl p-6 md:p-8">
              <h3 className="text-lg font-heading text-foreground-900 mb-4">
                快速留言
              </h3>
              <p className="text-sm text-foreground-600 mb-4">
                如有任何建议或问题，欢迎通过以上邮箱联系我们，我们会在24小时内回复。
              </p>
              <div className="space-y-3">
                <div className="px-4 py-3 bg-background-100 rounded-lg text-sm text-foreground-500">
                  请输入您的邮箱
                </div>
                <div className="px-4 py-3 bg-background-100 rounded-lg text-sm text-foreground-500 h-28">
                  请输入留言内容
                </div>
                <button className="px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer opacity-60">
                  发送留言
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}